import { useSelector } from 'react-redux'

import { selectCurrentRoom } from '@store/actionSlices/appConfig'

import {
  selectShowcaseRoomConfigFromResult,
  useGetShowcaseRoomConfigQuery,
} from '@api/showcase-room'

interface ComponentProps {
  projectName: string
}

const useGetShowcaseRoomsConfig = ({ projectName }: ComponentProps) => {
  const currentRoom = useSelector(selectCurrentRoom)

  const { isLoaded, showcaseRoomConfig } = useGetShowcaseRoomConfigQuery(
    {
      projectName,
      showcaseRoomId: currentRoom,
    },
    {
      selectFromResult: selectShowcaseRoomConfigFromResult,
      skip: !currentRoom,
    }
  )

  return {
    isLoaded,
    navigationSettings: showcaseRoomConfig?.navigationSettings || [],
    theme: {
      font: showcaseRoomConfig?.theme?.font || '',
      mainColour: showcaseRoomConfig?.theme?.mainColor || '',
      secondaryColour: showcaseRoomConfig?.theme?.secondaryColor || '',
      tertiaryColour: showcaseRoomConfig?.theme?.tertiaryColor || '',
      neutralColour: showcaseRoomConfig?.theme?.neutralColor || '',
    },
    templates: showcaseRoomConfig?.templates || {},
    videoScreensaver: {
      enabled: showcaseRoomConfig?.screenSaver?.enabled,
      videoUrl: showcaseRoomConfig?.screenSaver?.videoUrl,
      delay: showcaseRoomConfig?.screenSaver?.delay,
    },
  }
}

export default useGetShowcaseRoomsConfig
